// extracted by mini-css-extract-plugin
export var radioInputRow = "B_tM";
export var radioInputColumn = "B_tN";
export var inputOptionRow = "B_sx";
export var inputOptionColumn = "B_sy";